<template>
  <div>
    <p class="settingsSubheader">Environment Information</p>
    <p class="settingsDescription">
      Current deployment configuration and infrastructure details for this application.
    </p>

    <div class="mt-6 space-y-6">
      <!-- API Deployment -->
      <n-card title="API Deployment" size="small" :bordered="true">
        <div class="space-y-2">
          <div class="flex items-start">
            <span class="font-semibold w-32">Azure Tenant:</span>
            <span class="text-gray-700">Anthony.P.Goodman</span>
          </div>
          <div class="flex items-start">
            <span class="font-semibold w-32">Service:</span>
            <span class="text-gray-700">Azure App Service</span>
          </div>
          <div class="flex items-start">
            <span class="font-semibold w-32">Endpoint:</span>
            <span class="text-gray-700 break-all">{{ apiBaseUrl }}</span>
          </div>
        </div>
      </n-card>

      <!-- UI Deployment -->
      <n-card title="UI Deployment" size="small" :bordered="true">
        <div class="space-y-2">
          <div class="flex items-start">
            <span class="font-semibold w-32">Azure Tenant:</span>
            <span class="text-gray-700">Anthony.P.Goodman</span>
          </div>
          <div class="flex items-start">
            <span class="font-semibold w-32">Service:</span>
            <span class="text-gray-700">Azure Static Web Apps</span>
          </div>
          <div class="flex items-start">
            <span class="font-semibold w-32">URL:</span>
            <span class="text-gray-700 break-all">{{ currentUrl }}</span>
          </div>
        </div>
      </n-card>

      <!-- Authentication -->
      <n-card title="Authentication" size="small" :bordered="true">
        <div class="space-y-2">
          <div class="flex items-start">
            <span class="font-semibold w-32">Provider:</span>
            <span class="text-gray-700">Microsoft Entra ID</span>
          </div>
          <div class="flex items-start">
            <span class="font-semibold w-32">Tenant:</span>
            <span class="text-gray-700">Anthony.P.Goodman</span>
          </div>
          <div class="flex items-start">
            <span class="font-semibold w-32">Tenant ID:</span>
            <span class="text-gray-700 font-mono text-sm">a30aea0a-01e4-4fad-afd5-b662a8ce46bb</span>
          </div>
          <div class="flex items-start">
            <span class="font-semibold w-32">Client ID:</span>
            <span class="text-gray-700 font-mono text-sm">1fca1ddf-39de-43f9-a6f3-eb06d22719e6</span>
          </div>
        </div>
      </n-card>

      <!-- Database -->
      <n-card title="Database" size="small" :bordered="true">
        <div class="space-y-2">
          <div class="flex items-start">
            <span class="font-semibold w-32">Azure Tenant:</span>
            <span class="text-gray-700">Anthony.P.Goodman</span>
          </div>
          <div class="flex items-start">
            <span class="font-semibold w-32">Service:</span>
            <span class="text-gray-700">AcornDB</span>
          </div>
          <div class="flex items-start">
            <span class="font-semibold w-32">Type:</span>
            <span class="text-gray-700">Document Store (Azure Blob Storage)</span>
          </div>
        </div>
      </n-card>
    </div>
  </div>
</template>

<script>
import { defineComponent, computed } from "vue";
import { useStore } from "vuex";
import axios from "axios";

export default defineComponent({
  name: "SettingsEnvironment",
  setup() {
    const store = useStore();

    const msalConfig = computed(() => store.getters.getMsalConfig);

    const tenantId = computed(() => {
      const authority = msalConfig.value?.auth?.authority || "";
      const match = authority.match(/login\.microsoftonline\.com\/([^/]+)/);
      return match ? match[1] : "N/A";
    });

    const clientId = computed(() => {
      return msalConfig.value?.auth?.clientId || "N/A";
    });

    const apiBaseUrl = computed(() => {
      return axios.defaults.baseURL || "N/A";
    });

    const currentUrl = computed(() => {
      return window.location.origin;
    });

    return {
      tenantId,
      clientId,
      apiBaseUrl,
      currentUrl,
    };
  },
});
</script>

<style scoped>
.space-y-6 > * + * {
  margin-top: 1.5rem;
}

.space-y-2 > * + * {
  margin-top: 0.5rem;
}

.break-all {
  word-break: break-all;
}
</style>
